import React from 'react'
import { LayoutManagerInterpreter } from 'midi-city-app-manager/src/layout-manager'

// @ts-expect-error
const LayoutManagerContext = React.createContext<LayoutManagerInterpreter>()

export default LayoutManagerContext
